import React from 'react';

export const Logo = ({ className = "w-10 h-10" }) => {
  return (
    <img
      src="/logo-opensyne.svg"
      alt="Open Syne"
      className={className}
    />
  );
};
